import { Injectable, inject } from "@angular/core";
import { LocalRepository } from '@shared/helper/local-repository';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { TServiceResult } from '@shared/helper/t-service-result';
import { CreateLikeModel, LikeModel } from '@shared/model/customerModels/like-model';
import { PageList } from '@shared/model/categoryAndSearch/pageList-model';
import { ServiceResult } from '@shared/helper/service-result';
import { HttpBaseService } from '../base_services/http_base.service';
import { switchMap } from "rxjs/operators";
import { LikeAggrigatorService } from "./Activity_Aggrigator/likeAggrigator.service";


@Injectable({
    providedIn: "root"
})
export class LikesService extends HttpBaseService {
    private likeAggrigatorService = inject(LikeAggrigatorService);

    constructor() {
        const repo = inject(LocalRepository);
        const http = inject(HttpClient);

        super(repo, http, 'li');
    }

    getLikeById(id: number): Observable<TServiceResult<LikeModel>> {
        return this.http.get<TServiceResult<LikeModel>>(`${this.apiUrl}/get/${id} `);
    }

    getAllLikes(): Observable<TServiceResult<PageList<LikeModel>>> {
        return this.http.get<TServiceResult<PageList<LikeModel>>>(`${this.apiUrl}/GetAll`);
    }

    updateLike(like: LikeModel): Observable<ServiceResult> {
        return this.http.put<ServiceResult>(`${this.apiUrl}/Update`, like);
    }

    UnLike(objectId: string): Observable<ServiceResult> {
        return this.http.delete<ServiceResult>(`${this.apiUrl}/UnLike/${objectId}`).pipe(
            switchMap((res) => of(res))
        );
    }

    createLike(like: CreateLikeModel, userId: string): Observable<ServiceResult> {
        if (this.isLikedObject(like)) {
            // ? Remove Like
            return this.UnLike(like.objectId);
        }
        else {
            // ? Create Like
            const likeObject = this.likeObjectGenerator(like, userId);
            return this.likeAggrigatorService.getLike(likeObject)
        }
    }

    private isLikedObject(likedObject: CreateLikeModel): boolean {
        return likedObject.userLiked!;
    }

    private likeObjectGenerator(likedObject: CreateLikeModel, userId: string): LikeModel {
        const likedObjectInstance = new LikeModel();
        likedObjectInstance.objectId = likedObject.objectId;
        likedObjectInstance.objectType = likedObject.objectType;
        likedObjectInstance.userId = userId;
        likedObjectInstance.objectOwner = likedObject.objectOwner;
        if (likedObject.bookId) {
            likedObjectInstance.bookId = likedObject.bookId
        }
        return likedObjectInstance;
    }

}
